import {isNil, sort} from 'ramda';

import i18n from '../../../../../i18n/i18n';

export type IsKnownPresetFeature = (featureKey: string) => boolean;

const MAX_FEATURE_TAGS = 4;
const VISIBLE_FEATURE_LABELS_BEFORE_AND_MORE = 3;

export function normalizePresetFeatures(
  features: string[] | null | undefined,
  isKnownFeature: IsKnownPresetFeature
): string[] | null {
  if (isNil(features) || features.length === 0) {
    return null;
  }

  const knownFeatures = features.filter(isKnownFeature);
  return knownFeatures.length > 0 ? knownFeatures : null;
}

export function resolvePresetFeaturesForForm(
  features: string[] | null | undefined,
  isKnownFeature: IsKnownPresetFeature
): string[] {
  return normalizePresetFeatures(features, isKnownFeature) ?? [];
}

export function getFeaturesPresetTags(
  features: string[] | null | undefined,
  getFeatureLabel: (featureKey: string) => string,
  isKnownFeature: IsKnownPresetFeature
): string[] {
  const normalized = normalizePresetFeatures(features, isKnownFeature);
  if (isNil(normalized)) {
    return [];
  }

  const labels = sort(
    (left, right) => getFeatureLabel(left).localeCompare(getFeatureLabel(right)),
    normalized
  ).map(getFeatureLabel);

  if (labels.length <= MAX_FEATURE_TAGS) {
    return labels;
  }

  const remainingCount = labels.length - VISIBLE_FEATURE_LABELS_BEFORE_AND_MORE;

  return [
    ...labels.slice(0, VISIBLE_FEATURE_LABELS_BEFORE_AND_MORE),
    i18n.t('entity.filterForm.savedFilters.summary.features.andMore', {count: remainingCount}),
  ];
}
